export default "__VITE_ASSET__67e3c8ca__"